import React from 'react';
import { scrollToCompra } from '../utils/scroll';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  href?: string;
  className?: string;
  pulse?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  pulse = false,
  fullWidth = true
}: ButtonProps) {
  const baseClasses = 'relative inline-flex items-center justify-center font-sans font-bold text-white bg-brand-cta hover:bg-brand-ctaDark transition-colors duration-200 rounded px-4 py-3 md:px-6 md:py-4 text-sm md:text-base text-center uppercase tracking-wide border border-transparent';
  const widthClasses = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick(e);
    } else if (!href) {
      scrollToCompra(e);
    }
  };
  if (href) {
    return <a href={href} className={`${baseClasses} ${widthClasses} ${className}`} target="_blank" rel="noopener noreferrer" data-id="element-66">
        {children}
      </a>;
  }
  return <button onClick={handleClick} className={`${baseClasses} ${widthClasses} ${className}`} data-id="element-67">
      {children}
    </button>;
}